import { fetchUpgradeBannerConfig, validateBannerUpgradeConfig } from './utils';
export const fetchValidatedBannerUpgradeConfig = ({
  upgradeKey,
  limit,
  usage
}) => {
  return fetchUpgradeBannerConfig({
    upgradeKey,
    limit,
    usage
  }).then(upgradePointResponse => {
    if (!upgradePointResponse) return {};
    try {
      validateBannerUpgradeConfig(upgradePointResponse);
    } catch (validationError) {
      console.error(validationError);
      throw validationError;
    }
    return {
      upgradeConfig: upgradePointResponse
    };
  });
};